module.exports = __webpack_public_path__ + "img/motorbikeRearLeft.29954a30.svg";